module.exports = __webpack_public_path__ + "img/ico_energy_green.896d997a.png";